import React from 'react';
import Aux from '../../../../hoc/_Aux';

const Zigzag = (props) => {

    let shapeStyle = {};
    if(props.color){
        shapeStyle.fill = props.color;
    }
    if(props.translateXaxis){
        shapeStyle = Object.assign({transform: 'translateX('+props.translateXaxis+'px)'}, shapeStyle);
    } 

    return(
        <Aux>
            <svg id="zigzap-shape" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 14" style={shapeStyle} >
                <g>
                    <path className="shape-color" d="M198.989,40.221l-6.974-6.974L186.761,38.5,183.5,35.239l8.514-8.514,6.974,7.065,6.7-6.7L212.3,33.7,220,26l6.34,6.34,5.072-5.072,3.17,3.261-8.243,8.333L220,32.522l-7.7,7.7-6.612-6.612Z" transform="translate(-183.5 -26)"/>
                </g>
            </svg>
        </Aux>
    );
}

export default Zigzag;



// WEBPACK FOOTER //
// ./src/containers/UI/Common/Shapes/Zigzag.js